(function($){

// ---------- Header START
var Header = {

  config: {
  },

  nav: {
    IS_OPEN: false
  },

  menu: {
    levels: []
  },

  mobileCreatedElements: [],
  desktopCreatedElements: [],

  init: function(){
    Header.initNav();
    $(Header.desktopCreatedElements).each(function(){ $(this).hide(); });

    enquire.register('screen and (min-width: 64em)', {
      match: function() {
        $(Header.mobileCreatedElements).each(function(){ $(this).hide(); });
        $(Header.desktopCreatedElements).each(function(){ $(this).show(); });

        $(Header.menu.levels).each(function(index){
          Header.closeLevel(index);
        });

        Header.removeDefaultMenuListeners();


        Header.addWideMenuListeners();

        Header.resizeCols();
        $(window).resize($.throttle(250, Header.resizeCols));

        Header.toggleNavLogo();
        $(window).scroll($.throttle(250, Header.toggleNavLogo));
      },
      unmatch: function() {
        $(Header.mobileCreatedElements).each(function(){ $(this).show(); });
        $(Header.desktopCreatedElements).each(function(){ $(this).hide(); });

        Header.closeNav();

        Header.removeWideMenuListeners();
        Header.addDefaultMenuListeners();

        $(window).off('resize', Header.resizeCols);
        window.setTimeout(function(){ Header.resizeCols('reset'); }, 250);

        $(window).off('resize', Header.toggleNavLogo);
        window.setTimeout(function(){ $('.nav__home').removeClass('is-displayed'); }, 250);
      }
    });
  },

  initNav: function(){
    var $menuTogglerClone = $('.nav .main-menu-toggler').clone();
    var $langSwitchClone = $('.nav .lang-switch').clone();
    $('.header').append($menuTogglerClone, $langSwitchClone);

    Header.mobileCreatedElements.push($menuTogglerClone, $langSwitchClone);

    var $miniLogo = $('<li class="main-menu__item m--logo"><svg role="img" class="svg-icon mini-logo"><use xlink:href="/wp-content/themes/vista-ar/images/pictos/misc.sprite.svg#mini-logo"></use></svg></li>');
    $('.main-menu__items').prepend($miniLogo);
    Header.desktopCreatedElements.push($miniLogo);

    $('.main-menu-toggler').on('click', Header.toggleNav);

    $('.main-menu__link').each(function(index, element){
      var toggler = $(element);
      var item = $(element).parent();
      var lvl = $(toggler.parent().find('.main-menu__subitems')[0]);
      var back = $('<li class="main-menu__subtitle"><svg role="img" class="svg-icon chevron-left "><use xlink:href="/wp-content/themes/vista-ar/images/pictos/misc.sprite.svg#chevron-left"></use></svg>' + toggler.text() + '</li>');

      lvl.prepend(back);
      Header.mobileCreatedElements.push(back);

      if(lvl.length){
        Header.menu.levels[index] = {
          item: item,
          toggler: toggler,
          lvl: lvl,
          back: back,
          IS_OPEN: false
        };

        var $chevron = $('<svg role="img" class="svg-icon chevron-right"><use xlink:href="/wp-content/themes/vista-ar/images/pictos/misc.sprite.svg#chevron-right"></use></svg>');
        Header.mobileCreatedElements.push($chevron);
        toggler.append($chevron);

        toggler.data('level-index', index);
        item.data('level-index', index);
        back.data('level-index', index);

        Header.closeLevel(index);

        // Bind tab
        $(window).on('keyup', function (e) {
          var keyCode = e.keyCode || e.which;

          if ($(e.target).closest(lvl).length || e.target == toggler[0]) {
            if(keyCode == 9){
              Header.openLevel(index);
            }
          } else {
            Header.closeLevel(index);
          }
        }.bind(this));
      }
    });


    Header.addDefaultMenuListeners();
  },

  toggleNav: function(){
    if(!Header.nav.IS_OPEN){
      Header.openNav();
    } else {
      Header.closeNav();
    }
  },

  openNav: function(){
    $('.main-menu-toggler').addClass('is-open');
    $('#nav').addClass('is-open');
    $('body').addClass('is-overlayed');
    Header.nav.IS_OPEN = true;

    if(Header.config.matchHeightFlag === true) setTimeout($.fn.matchHeight._update, 250);

    setTimeout(function(){ $(window).trigger('afterNavOpen'); } , 250);
  },

  closeNav: function(){
    $('.main-menu-toggler').removeClass('is-open');
    $('#nav').removeClass('is-open');
    $('body').removeClass('is-overlayed');
    Header.nav.IS_OPEN = false;

    $(Header.menu.levels).each(function(index){
      Header.closeLevel(index);
    });

    if(Header.config.matchHeightFlag === true) setTimeout($.fn.matchHeight._update, 250);

    setTimeout(function(){ $(window).trigger('afterNavClose'); } , 250);
  },

  addDefaultMenuListeners: function(){
    $(Header.menu.levels).each(function(index){
      if(Header.menu.levels[index] !== undefined){
        Header.menu.levels[index].toggler.on('click', Header.openLevel);
        Header.menu.levels[index].back.on('click', Header.closeLevel);
      }
    });
  },

  removeDefaultMenuListeners: function(){
    $(Header.menu.levels).each(function(index){
      if(Header.menu.levels[index] !== undefined){
        Header.menu.levels[index].toggler.off('click', Header.openLevel);
        Header.menu.levels[index].back.off('click', Header.closeLevel);
      }
    });
  },

  addWideMenuListeners: function(){
    $(Header.menu.levels).each(function(index){
      if(Header.menu.levels[index] !== undefined){
        Header.menu.levels[index].item.on('mouseover', Header.openLevel)
          .on('mouseout', Header.closeLevel);
      }
    });
  },

  removeWideMenuListeners: function(){
    $(Header.menu.levels).each(function(index){
      if(Header.menu.levels[index] !== undefined){
        Header.menu.levels[index].item.off('mouseover', Header.openLevel)
          .off('mouseout', Header.closeLevel);
      }
    });
  },

  // toggleLevel: function(e){
  //   var index = $(this).data('level-index');

  //   if(Header.menu.levels[index].IS_OPEN){
  //     Header.closeLevel(index);
  //   } else {
  //     Header.openLevel(index);
  //   }
  // },

  openLevel: function(index){
    index = typeof index === 'object' || index === undefined ? $(this).data('level-index') : index;
    $('body').addClass('main-menu-lvl-open');
    Header.menu.levels[index].toggler.addClass('is-open');
    Header.menu.levels[index].lvl.addClass('is-open');
    Header.menu.levels[index].IS_OPEN = true;
    return false;
  },

  closeLevel: function(index){
    index = typeof index === 'object' || index === undefined ? $(this).data('level-index') : index;
    $('body').removeClass('main-menu-lvl-open');
    if(Header.menu.levels[index] != undefined) {
      Header.menu.levels[index].toggler.removeClass('is-open');
      Header.menu.levels[index].lvl.removeClass('is-open');
      Header.menu.levels[index].IS_OPEN = false;
    }
    return false;
  },

  setHeaderStyle: function(){
    if($(window).scrollTop() > 1){
      $('.header').addClass('is-min');
    } else {
      $('.header').removeClass('is-min');
    }
  },

  resizeCols: function(opt){
    var cols = $('.main-menu__scroller, .main-menu__items, .main-menu__subitems');
    var max = 0;

    cols.css({ height: '', paddingTop: '', paddingBottom: '' });

    if(opt !== 'reset'){
      cols.each(function(){
        if($(this).outerHeight() > max){
          max = $(this).outerHeight();
        }
      });

      cols.each(function(){
        if(!$(this).hasClass('main-menu__scroller')){
          if($(this).hasClass('main-menu__subitems') && $(this).outerHeight() !== max){
            var newPadding = (max - $(this).outerHeight()) / 2;
            $(this).css({ paddingTop: newPadding + 'px', paddingBottom: newPadding + 'px' });
          }

          if($(this).hasClass('main-menu__items') && $('.main-menu__scroller').outerHeight() < max){
            $(this).css('height', max);
          }
        }
      });
    }
  },

  toggleNavLogo: function(){
    /*if($(window).scrollTop() >= ($('.header__title').offset().top +  $('.header__title').outerHeight())){
      $('.nav__home').addClass('is-displayed');
    } else {
      $('.nav__home').removeClass('is-displayed');
    }*/
  }

};
// ---------- HEADER END

// Init Header
$(document).ready(Header.init);

})(jQuery);
